import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';

@Component({
  selector: 'app-show-warning',
  templateUrl: './show-warning.component.html',
  styleUrls: ['./show-warning.component.scss']
})
export class ShowWarningComponent implements OnInit, OnDestroy {

  locked: boolean = false;

  constructor(
    public infraService: InfrastructureService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

}
